import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useWidgetHost, useWidgetState} from '../../../hooks/state-provider'
import {useEventsList} from '../../../hooks/use-events-list'
import {getCompId} from '../../../selectors/component'
import {isNarrow} from '../../../selectors/list-settings'
import {focusFirstNewEvent} from '../../../utils/a11y'
import {CategoryTabs} from '../../category-tabs'
import {EmptyCategory} from '../../category-tabs/empty-category'
import {LoadMoreButton} from '../../load-more-button'
import {MainListTitle} from '../../main-list-title'
import {DesktopItem} from '../item'
import s from './list.scss'

export const List = () => {
  const {events, hasMore, moreLoading, pageLimit} = useEventsList()
  const {experiments} = useExperiments()

  const host = useWidgetHost()
  const narrow = useWidgetState(state => isNarrow(state, host.dimensions))
  const mobile = useWidgetState(isMobile)
  const compId = useWidgetState(getCompId)
  const eventsCount = events.length

  const style: React.CSSProperties = {
    overflowY: narrow && !mobile ? 'scroll' : 'hidden',
    height: narrow && !mobile ? '100%' : 'auto',
  }
  const className = classNames(s.container, s.scrollBarColor, s.padding)

  useEffect(() => {
    focusFirstNewEvent({eventsCount, pageLimit, hasMore, compId})
  }, [eventsCount])

  return (
    <div className={className} style={style} data-hook="ev-list-layout">
      <MainListTitle />
      <CategoryTabs />
      {!events.length && experiments.enabled(ExperimentNames.CategoryTabsUoU) ? (
        <EmptyCategory />
      ) : (
        <>
          <ul>
            {events.map(event => (
              <DesktopItem key={event.id} event={event} />
            ))}
          </ul>
          <LoadMoreButton hasMore={hasMore} moreLoading={moreLoading} />
        </>
      )}
    </div>
  )
}
